//components
import { SectionWrap } from '@/containers-ai/SectionHeading';
import { PillLink, GhostLink } from '@/containers-ai/Buttons';

//styles
import {
  EndCTASection,
  Title,
  TitleHighlight,
  Copy,
  CtaRow,
} from './EndCTA.styles';

export function EndCTA({ agentName, showSecondaryCta = false }) {
  return (
    <EndCTASection id="cta">
      <SectionWrap>
        <Title>
          Bring the workflow{' '}
          <TitleHighlight>that bothers you most.</TitleHighlight>
        </Title>
        <Copy>
          See the {agentName} agent run against your own freight, in a
          working session with the team that builds it.
        </Copy>
        <CtaRow>
          <PillLink
            href="/contact/#contact-form"
            style={{ fontSize: '16px', padding: '16px 32px' }}
            className="qlf-btn-2"
          >
            Book a working session &#8594;
          </PillLink>
          {showSecondaryCta && (
            <GhostLink
              href="/ai/"
              style={{ fontSize: '16px', padding: '16px 28px' }}
            >
              See all six agents
            </GhostLink>
          )}
        </CtaRow>
      </SectionWrap>
    </EndCTASection>
  );
}
